module.exports = __webpack_public_path__ + "static/ReadingSideDoodle2-8f480a1cabe570d3b0c062486cd37fb6.png";